import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './actions';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type FireInsuranceAgentsSearchStateModel = AlgoliaBaseState<unknown>;

@State<FireInsuranceAgentsSearchStateModel>({
	name: 'fireInsuranceAgentsSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class FireInsuranceAgentsSearchState extends AlgoliaSearchState<FireInsuranceAgentsSearchStateModel> {
	protected indexName = getIndex(IndexType.FIRE_INSURANCE_AGENTS);

	@Selector([FireInsuranceAgentsSearchState])
	static getList(state: FireInsuranceAgentsSearchStateModel): unknown[] {
		return state?.items;
	}

	@Selector([FireInsuranceAgentsSearchState])
	static getSearching(state: FireInsuranceAgentsSearchStateModel): boolean {
		return state?.searching;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<FireInsuranceAgentsSearchStateModel>,
		{ payload }: actions.Search,
	): Promise<void> {
		const facetFilters = [];
		if (payload?.companyId) {
			facetFilters.push(`companyId:${payload.companyId}`);
		}

		await this.algoliaSearchHandler(ctx, payload?.searchTerm, {
			facetFilters,
		});
	}
}
